import { render, staticRenderFns } from "./feeDetailRoom.vue?vue&type=template&id=5e97c0a2"
import script from "./feeDetailRoom.vue?vue&type=script&lang=js"
export * from "./feeDetailRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports